import { DocumentNode, OperationDefinitionNode } from 'graphql'

import { Configuration } from '../ConfigurationLoader/types'
import { redis } from './redis'

const GLOBAL_CACHE_PREFIX = 'gql'

const gqlQueryCacheKeyBuilder = (
  config: Configuration,
  query: DocumentNode,
  cachePrefix?: string,
) => {
  const operation = query.definitions.find(
    (definition) => definition.kind === 'OperationDefinition',
  ) as OperationDefinitionNode | undefined
  if (typeof operation?.name?.value !== 'string') {
    console.warn(
      'Cannot cache query because operation name isnt a valid string',
    )
    return undefined
  }

  return [
    GLOBAL_CACHE_PREFIX,
    cachePrefix,
    config.publicRuntimeConfig.siteDefinition.brand,
    config.publicRuntimeConfig.siteDefinition.subsite,
    operation.name.value,
  ].join(':')
}

export const cacheGQLQuery = async <T>(request: {
  config: Configuration
  query: DocumentNode
  ttl: number
  cachePrefix?: string
  lookup: () => Promise<T | undefined>
}): Promise<T | undefined> => {
  const cacheKey = gqlQueryCacheKeyBuilder(
    request.config,
    request.query,
    request.cachePrefix,
  )

  let cachedResponse: T | undefined
  if (cacheKey && redis) {
    const cachedData = await redis.get(cacheKey)
    if (cachedData) {
      cachedResponse = JSON.parse(cachedData)
    }
  }

  if (!cachedResponse) {
    cachedResponse = await request.lookup()

    if (cacheKey && redis) {
      await redis.set(
        cacheKey,
        JSON.stringify(cachedResponse),
        'ex',
        request.ttl,
      )
    }
  }

  return cachedResponse
}
